export default {
    defaultProps: {
        color: null,
        size: null,
    },
};
